module.exports = __webpack_public_path__ + "static/media/onboarding-guy.0a60140a.png";